module.exports = __webpack_public_path__ + "static/img/score_header.a671619.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/scoreShop/score_header.png
// module id = YUTx
// module chunks = 1